<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.category_assets_id" :error="form.errors.category_assets_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" :required="true">
            <option :value="null">{{ __('Select Category') }}</option>
            <option v-for="s in category" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <select-input v-model="form.brand_assets_id" :error="form.errors.brand_assets_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Brand')" :required="true">
            <option :value="null">{{ __('Select Brand') }}</option>
            <option v-for="s in brand" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Type Name')" />

          <textarea-input v-model="form.description" :error="form.errors.description" :rows="8" class="pb-6 w-full lg:w-1/2" placeholder="description here.." :label="__('Description')"></textarea-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create Data') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

          <script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create a New Asset Type' },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
    SelectInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    category: Array,
    brand: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        category_assets_id: null,
        brand_assets_id: null,
        description: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('asset_type.store'))
    },
  },
}
</script>
